import { RootState } from "@/redux/rootReducer";
import { capitalize } from "@/utils/global";

type MakeGetSelectorsReturnType<State> = {
	[K in keyof State as `get${Capitalize<string & K>}`]: (
		rootState: RootState,
	) => State[K];
};

export function makeGetSelectors<StateKey extends keyof RootState, StateKeyList>(
	stateKey: StateKey,
	stateKeyList: Array<keyof StateKeyList>,
) {
	return stateKeyList.reduce(
		(prev, value) => ({
			...prev,
			[`get${capitalize(value.toString())}`]: ({
				[stateKey]: { [value]: state },
			}: RootState) => state,
		}),
		{} as MakeGetSelectorsReturnType<RootState[StateKey]>,
	);
}
